var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFree = function SvgFree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.984 26.65H23.17v1.995h-7.525V39.32h6.265v1.96h-6.265V55h-2.66V26.65Z",
    fill: "#fff"
  })), "{\" \"}", _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.485 26.65h6.405c2.544 0 4.352.618 5.425 1.855 1.074 1.213 1.61 2.998 1.61 5.355 0 1.797-.291 3.278-.875 4.445-.583 1.167-1.598 1.902-3.045 2.205L40.345 55h-2.59L33.59 41.07h-4.445V55h-2.66V26.65Zm6.265 12.46c1.704 0 2.894-.42 3.57-1.26.677-.84 1.015-2.17 1.015-3.99 0-1.843-.326-3.173-.98-3.99-.63-.817-1.808-1.225-3.535-1.225h-3.675V39.11h3.605Z",
    fill: "#fff"
  })), "{\" \"}", _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.36 26.65h10.255v2.065h-7.56v10.64h6.16v1.96h-6.16v11.69h7.63V55H44.36V26.65Z",
    fill: "#fff"
  })), "{\" \"}", _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.306 26.65H68.56v2.065H61v10.64h6.16v1.96H61v11.69h7.63V55H58.306V26.65Z",
    fill: "#fff"
  })), "{\" \"}", _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22.5c8.75-7.5 32-18 55 0",
    stroke: "#fff",
    strokeWidth: 2
  })), "{\" \"}", _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60c-8.75 7.5-32 18-55 0",
    stroke: "#fff",
    strokeWidth: 2
  })));
};
export default SvgFree;